import { marked } from "marked";

// LF360-2015 — the scenario editor previews an article in its Suggestions
// picker. The package renders plain text only, so the stored markdown or html
// is reduced to a short excerpt here.

export const EXCERPT_LENGTH = 600;

const BLOCK_TAGS = "p,div,li,h1,h2,h3,h4,h5,h6,blockquote,pre,tr,br";

/** The text of an article body as plain text, keeping paragraph breaks. */
export const toPlainText = (text, textFormat) => {
  if (!text) return "";

  const html = textFormat === "html" ? text : marked.parse(text, { async: false });
  const doc = new DOMParser().parseFromString(html, "text/html");
  doc.querySelectorAll("script,style,img,video,iframe").forEach((node) => node.remove());
  doc.querySelectorAll(BLOCK_TAGS).forEach((node) => node.after("\n"));

  return (doc.body.textContent || "")
    .replace(/[ \t]+/g, " ")
    .replace(/ *\n */g, "\n")
    .replace(/\n{2,}/g, "\n")
    .trim();
};

/** Cuts plain text to `length` on a word boundary. */
export const toExcerpt = (plainText, length = EXCERPT_LENGTH) => {
  if (plainText.length <= length) return plainText;

  const cut = plainText.slice(0, length);
  const lastSpace = cut.search(/\s\S*$/);
  return `${(lastSpace > 0 ? cut.slice(0, lastSpace) : cut).trimEnd()}…`;
};

/** GET /v1/pages/:id `page` -> the editor's ArticlePreview. */
export const articlePreviewFromPage = (page) => ({
  id: page.id,
  title: page.title || "",
  excerpt: toExcerpt(toPlainText(page.text, page.textFormat)) || null,
  imageUrl: page.imageThumbUrl || page.imageUrl || null,
  categories: page.Category?.name ? [page.Category.name] : [],
  tags: (page.tags || []).map((tag) => tag.name).filter(Boolean),
});
